<template>
    <div class="drawer">
        <el-drawer size="900px" title="添加" :visible.sync="drawerStatus" @close="close" :modal-append-to-body="false">
            <div class="contentCage">
                <div class="con">
                    <div class="cageSaff">订单号:
                        <el-input v-model="order_no" placeholder="订单号" size="small" style="width: 150px; margin-left: 5px"
                            @keyup.enter.native="handelComClick"></el-input>

                    </div>
                    <div class="cageSaff">购买用户的id:
                        <el-input v-model="user_id" placeholder="购买用户的id" size="small"
                            style="width: 210px; margin-left: 5px"></el-input>
                    </div>
                </div>
                <div class="con">
                    <div class="cageSaff">宠物ID:
                        <el-input v-model="pet_id" placeholder="宠物id" size="small"
                            style="width: 210px; margin-left: 5px"></el-input>
                    </div>
                    <div class="cageSaff">宠物名字:
                        <el-input v-model="pet_name" placeholder="宠物名字" size="small"
                            style="width: 150px; margin-left: 5px"></el-input>
                    </div>
                </div>

                <div class="con">
                    <div class="cageSaff">门店id:
                        <el-input v-model="shop_id" placeholder="门店id" size="small"
                            style="width: 210px; margin-left: 5px"></el-input>
                    </div>
                    <div class="cageSaff">门店名字:
                        <el-input v-model="shop_name" placeholder="门店名字" size="small"
                            style="width: 150px; margin-left: 5px"></el-input>
                    </div>
                </div>

                <div class="con">
                    <div class="cageSaff">购买用户的名字:
                        <el-input v-model="user_name" placeholder="购买用户的名字" size="small"
                            style="width: 150px; margin-left: 5px"></el-input>
                    </div>
                    <div class="cageSaff">购买用户的手机号:
                        <el-input v-model="user_mobile" placeholder="购买用户的手机号" size="small"
                            style="width: 150px; margin-left: 5px"></el-input>
                    </div>

                </div>
                <div class="con">
                    <div class="cageSaff">时间:

                        <el-input disabled :value="$public.FTime(create_time)" placeholder="时间" size="small"
                            style="width: 170px; margin-left: 5px"></el-input>
                    </div>
                    <div class="cageSaff">可改变时间:
                        <el-date-picker v-model="create_time1" type="datetime" placeholder="选择日期时间" default-time="12:00:00"
                            value-format="timestamp" @change="handleTime">
                        </el-date-picker>
                    </div>
                </div>
                <div class="comView">
                    <div class="comItem" v-for="(item, index) in selectBrandIndex" :key="item.staff_id">
                        {{ item.staff_name }} <el-input v-model.number="item.money" placeholder="奖金" size="small"
                            style="width: 60px; margin-left: 5px"></el-input>
                        <span class="el-icon-close" @click="handleBrandClose(index)"></span>

                    </div>
                </div>
                <div class="con">
                    <div>
                        负责人:<el-select style="width: 150px; margin-left: 10px" v-model="breederId" filterable
                            @change="secle" placeholder="请选择">
                            <el-option v-for="(item, index) in salesList" :key="index" :label="item.nick_name"
                                :value="item._id + ',' + item.nick_name">
                            </el-option>
                        </el-select>
                        <!-- <el-input v-model="money" placeholder="奖金" size="small"
                            style="width: 150px; margin-left: 5px"></el-input> -->
                    </div>

                </div>
                <!-- <div class="con">
                        <div>
                            医生:<el-select v-model="doctorId" @change="secle" style="width: 150px; margin-left: 5px" placeholder="请选择">
                                <el-option v-for="item in doctorList" :key="item._id" :label="item.basic_info.nick_name"
                                    :value="item._id+ ',' +item.basic_info.nick_name">
                                </el-option>
                            </el-select>
                            <el-input v-model="money" placeholder="奖金" size="small"
                                style="width: 150px; margin-left: 5px"></el-input>
                        </div>
                    </div>
                    <div class="con">
                        <div>
                            医助:<el-select v-model="doctorAssistantId" style="width: 150px" placeholder="请选择">
                                <el-option v-for="item in assistantList" :key="item._id" :label="item.basic_info.nick_name"
                                    :value="item._id">
                                </el-option>
                            </el-select>
                            <el-input v-model="money" placeholder="奖金" size="small"
                                style="width: 150px; margin-left: 5px"></el-input>
                        </div>
                    </div>
                    <div class="con">
                        <div>
                            美容师:<el-select v-model="beauticianId" style="width: 150px; margin-left: 5px" placeholder="请选择">
                                <el-option v-for="item in beauticianList" :key="item._id" :label="item.basic_info.nick_name"
                                    :value="item._id">
                                </el-option>
                            </el-select>
                            <el-input v-model="money" placeholder="奖金" size="small"
                                style="width: 150px; margin-left: 5px"></el-input>
                        </div>
                    </div> -->
                <div style="height: 20px"></div>

            </div>

            <div class="btnBox">
                <div class="btnItem">取消</div>
                <div class="btnItem submit" @click="sumbit">确定</div>
            </div>
        </el-drawer>
    </div>
</template>
  
<script>
import { petReceive } from "@/api/purchaseApi.js";
import { getStaffList } from "@/api/shopStaff.js";
export default {
    props: {

    },
    data() {
        return {
            pet_id: '',
            pet_name: '',
            order_no: '',
            shop_id: '',
            shop_name: '',
            user_id: '',
            user_name: '',
            user_mobile: '',
            create_time: '',
            create_time1: '',
            money: null,
            breederId: "",
            doctorAssistantId: "",
            beauticianId: "",
            doctorId: "",
            salesList: [],
            doctorList: [],
            beauticianList: [], //美容师
            breederList: [], //饲养员
            drawerStatus: false,
            selectBrandIndex: [], //选中订单类型
            params: {
                pageIndex: 1,
                pageSize: 100,
                keyword: "",
                shopId: '',
                position: "",
                status: 1,
            },
            zhuguanList: [],
            assistantList: [],//医助

        };
    },
    mounted() {
        this.$nextTick(() => {
            this.drawerStatus = true;
            this.getBreederList();
            // this.getSalesList();
            this.get()
        });
    },
    methods: {
        handleBrandClose(index) {
            this.selectBrandIndex.splice(index, 1);
        },
        handleTime(e) {
           

            this.create_time = String(e/1000)
            this.create_time1 = ''
            console.log( this.create_time,"12212");
            console.log(typeof(this.create_time),"12212");

        },
        secle(value) {
            for (var i = 0; i < this.selectBrandIndex.length; i++) {
                if (value.split(',')[0] == this.selectBrandIndex[i].id) {
                    this.$message({
                        type: "warning",
                        message: "已重复添加",
                    });
                    this.breederId = "";
                    return;
                }
                if (this.selectBrandIndex.length > 3) {
                    this.$message({
                        type: "warning",
                        message: "最多添加四位负责人",
                    });
                    this.breederId = "";
                    return;
                }
            }
            this.selectBrandIndex.push({ staff_id: value.split(',')[0], staff_name: value.split(',')[1], money: this.money })
            console.log(this.selectBrandIndex, "??????????");
            this.breederId = "";
        },
        async get() {
            this.params.position = "主管";
            let res = await getStaffList(this.params);
            if (res.code == 0) {
                this.zhuguanList = res.data.data;
                this.getBreederList()
            }
        },
        // 获取饲养员列表
        async getBreederList() {
            this.params.position = "";
            let res = await getStaffList(this.params);
            if (res.code == 0) {
                res.data.data.map(item => {
                    this.salesList.push({ _id: item._id, nick_name: item.basic_info.nick_name })
                })
            }
        },
        // // 获取销售列表
        // async getSalesList() {
        //     this.params.position = "销售";
        //     let res = await getStaffList(this.params);
        //     if (res.code == 0) {
        //         this.salesList = res.data.data;
        //         this.zhuguanList.map((item) => {
        //             this.salesList.push(item)
        //         })
        //         this.breederList.map((item) => {
        //             this.salesList.push(item)
        //         })
        //         this.getDoctorList();
        //     }
        // },

        // // 获取医生列表
        // async getDoctorList() {
        //     this.params.position = "医生";
        //     let res = await getStaffList(this.params);
        //     if (res.code == 0) {
        //         this.doctorList = res.data.data;
        //         this.getAssistantList()
        //     }
        // },
        // // 获取医助列表
        // async getAssistantList() {
        //     this.params.position = "医助";
        //     let res = await getStaffList(this.params);
        //     if (res.code == 0) {
        //         this.assistantList = res.data.data;
        //         this.getBeauticianList()
        //     }
        // },
        // // 获取美容师列表
        // async getBeauticianList() {
        //     this.params.position = "美容师";
        //     let res = await getStaffList(this.params);
        //     if (res.code == 0) {
        //         this.beauticianList = res.data.data;
        //     }
        //     console.log(res, "美容师");
        // },

        handelComClick() {
            this.$http
                .get(
                    process.env.VUE_APP_Url_order +
                    "/api/OffLineOrder/" +
                    this.order_no
                )
                .then((res) => {
                    console.log(res, "res");
                    this.user_id = res.data.user_info.user_id || ''
                    this.user_name = res.data.user_info.nick_name || ''
                    this.user_mobile = res.data.user_info.user_mobile || ''
                    this.shop_id = res.data.company_info.shop_id || ''
                    this.shop_name = res.data.company_info.shop_name || ''
                    this.pet_name = res.data.order_item_list[0].goods_name || ''
                    this.pet_id = res.data.order_item_list[0].goods_id || ''
                    this.create_time = res.data.pay_info.pay_time
                    console.log(this.create_time, "this.create_time");
                })
        },
        // 确定
        sumbit() {
            if (this.selectBrandIndex.length == 0) {
                this.$message({
                    type: "error",
                    message: "请至少选择一个负责人",
                });
                return;
            }
            if (this.order_no == '') {
                this.$message({
                    type: "error",
                    message: "请填写订单号",
                });
                return;
            }
            let params = {
                pet_id: this.pet_id,
                pet_name: this.pet_name,
                order_no: this.order_no,
                shop_id: this.shop_id,
                shop_name: this.shop_name,
                user_id: this.user_id,
                user_name: this.user_name,
                user_mobile: this.user_mobile,
                create_time: this.create_time,
                pet_head_staff_list: this.selectBrandIndex
            };
            console.log(params.create_time,"params");
            let loading = this.$loading();
            this.$http
                .post(process.env.VUE_APP_Url_8020 + "/api/StaffPerformance/AddStaffPerformanceByPetHead", params)
                .then((res) => {
                    loading.close();
                    this.$emit("submit");
                });

        },
        reset() {
            this.cageId = "";
            this.breederId = "";
            this.doctorAssistantId = "";
            this.beauticianId = "";
            this.doctorId = "";
        },

        handleChangEarea() {
        },
        // 关闭弹框
        close() {
            this.$emit("submit");
        },
    },
};
</script>
  
<style scoped lang="scss">
.drawer {
    ::v-deep .el-drawer__body {
        overflow-y: auto;
        padding-bottom: 30px;
    }

    .cageSaff {
        display: flex;
        line-height: 40px;
        width: 40%;

        &>div {
            display: flex;
            margin: 5px 3px;
        }
    }

    .contentCage {
        margin: 0px 20px;

        .con {
            // background: #fbfbfb;
            // border-radius: 16px;
            padding: 10px 0px;
            margin-bottom: 20px;
            display: flex;

            .contentItem {
                margin: 10px 0px;
                margin-left: 10px;
                display: flex;
                flex-wrap: wrap;

                .cageItem {
                    margin-bottom: 5px;
                    margin-right: 5px;
                    text-align: center;
                    border-radius: 8px;
                    background: #f5f5f6;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    width: 126px;
                    height: 80px;
                    cursor: pointer;
                }

                .lockClass {
                    color: #b0b0bf;
                }

                .pitchClass {
                    color: $mainColor;
                    border: 1px solid $mainColor;
                }
            }
        }

        .cageName {
            font-weight: 600;
            margin-top: 20px;
            border-left: 3px solid #0272da;
            padding-left: 20px;
            margin-bottom: 20px;
        }
    }

    .btnBox {
        width: 100%;
        font-size: 14px;
        color: #fff;
        line-height: 40px;
        display: flex;
        position: absolute;
        bottom: 0;
        z-index: 10;

        .btnItem {
            text-align: center;
            width: 100%;
            background-color: #d6d6d6;
            cursor: pointer;

            &.submit {
                background-color: $mainColor;
            }
        }
    }

    .comView {
        display: flex;
        align-items: center;
        text-align: center;
        line-height: 30px;

        .comItem {
            display: flex;
            align-items: center;
            text-align: center;
            line-height: 30px;
            margin: 0 10px;

        }
    }
}
</style>